import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@csx/security';
import { RolesAllowed } from '@csx/security';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (window.navigator.onLine && this.authService.isRoleAuthorized(["client.atam.eic"])) {
      if (this.authService.isAuthenticated) {
        return true;
      }

      if (!this.authService.isAuthenticated) {
        this.router.navigate(['/welcome']);
        return false;
      }
    } else if (!window.navigator.onLine) {
      return true;
    } else {
      this.router.navigate(['/logout'], { queryParams: { isAuthroized: false } });
      return false;
    }
  }
}